import { createUseStyles } from "react-jss";
import { ITheme } from "../../../store/slices/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  icon: {
    color: theme.colors.Background7,
    padding: theme.spacing.space8,
    margin: -theme.spacing.space8,
  },
  tabs: {
    padding: `${theme.spacing.space8}px ${theme.spacing.space16}px`,
  },
  balance: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    textAlign: "center",
    gap: 2,
  },
  spendableGems: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 4,
  },
  logo: {
    height: theme.spacing.space32,
    padding: theme.spacing.space4,
  },
  noti: {
    position: "relative",
  },
  redDot: {
    position: "absolute",
    top: 0,
    right: 0,
    width: 8,
    height: 8,
    borderRadius: "50%",
    backgroundColor: "#ff0000",
    border: "1px solid ff0000",
  },
}));
